<script setup>
import {defineProps, ref} from "vue";
import useSharedData from "@/use/SharedData";

defineProps({
    show: Boolean,
    disabled: Boolean,
    error: Boolean,
    block: Boolean,
})

const {loading} = useSharedData();

const printObject = ref({
    id: "pdfqleditor",
    previewTitle: false,
    beforeOpenCallback() {
        loading.value = true;
    },
    openCallback() {
        loading.value = false;
    },
    closeCallback() {
    },
});

</script>

<template>
    <w-btn
        v-if="show"
        :color="error ? 'red' : 'blue-grey'"
        :loading="loading"
        :disabled="disabled"
        :text="$t('common.print')"
        :icon="error ? 'mdi-alert' : 'mdi-printer'"
        v-print="printObject"
    />
</template>

<style scoped>

</style>